export default __webpack_public_path__ + "static/media/artist.4faedcaf.svg";